import { Trans } from "react-i18next";

/**
 * Shared “unlimited in Switzerland” note above rate cards.
 * Bold spans: <0> = country phrase, <1> = “unlimited”.
 */
export const RateTariffHint = () => (
  <p className="text-body-sm leading-none text-foreground-primary">
    <Trans
      i18nKey="Onboarding.sections.rate-selection.tariffHint"
      components={[
        <span key="switzerland" className="font-semibold" />,
        <span key="unlimited" className="font-semibold" />,
      ]}
    />
  </p>
);
